import type { Toast as ToastData } from '@/hooks/useToast';

interface ToastBarProps {
  toast: ToastData;
  onAction: () => void;
  onDismiss: () => void;
}

export function ToastBar({ toast, onAction, onDismiss }: ToastBarProps) {
  return (
    <div
      key={toast.id}
      className="fixed bottom-16 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-lg border border-border bg-surface px-4 py-3 shadow-lg animate-slide-up"
      role="status"
      aria-live="polite"
    >
      <p className="text-sm text-[var(--color-text)]">{toast.message}</p>
      {toast.actionLabel && (
        <button
          onClick={onAction}
          className="rounded-md bg-primary px-3 py-1 text-xs font-medium text-white hover:bg-primary-hover"
        >
          {toast.actionLabel}
        </button>
      )}
      <button
        onClick={onDismiss}
        className="rounded p-1 text-[var(--color-text-muted)] hover:bg-[var(--color-bg-tertiary)]"
        aria-label="Dismiss"
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
